











































import {Component, Vue} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import DataTableScanProducts from "@/components/lfs/NewStatistics/Elements/DataTableScanProducts.vue";
import DataScanFromCategory from "@/components/lfs/NewStatistics/Elements/DataScanFromCategory.vue";
import {sortBy} from "lodash";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";
import BtnDefault from "@/components/UI/BtnDefault.vue";
import Router from "@/router";
import {colorsChart} from "@/helpers/colorsChart";

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'Scannings',
  components: {BtnDefault, ErrorFetchingData, DataTableScanProducts, DataScanFromCategory}
})
export default class Scannings extends Vue {
  @statistic_v4.Getter('productScans') protected productScans!: any
  @statistic_v4.Getter('productByThematics') protected productByThematics!: any
  @statistic_v4.Getter('loading') protected loading!: any
  @statistic_v4.Getter('error') protected error!: any
  @statistic_v4.Action('loadScannings') protected loadScannings!: any

  get normalizeItems() {
    if (!this.productByThematics.length) return []
    const sorted = this.productByThematics.map((ele: any, idx: number)=>{
      const colorsCount = this.colors.length - 1
      return {
        name: ele.categoryTitle ? ele.categoryTitle : this.$t('newstatistics.v4.scannings.empty_product'),
        color: this.colors[idx % colorsCount],
        count: ele.value,
        data: [{
          y: ele.value,
          name: ele.categoryTitle,
          x: idx,
        }],
      }})
    return sortBy(sorted, ['count']).reverse()
  }
  get hasScannedProductCategories() {
    if (!this.productByThematics.length) return false
    return this.productByThematics.some((product: any) => product.value)
  }

  toProducts() {
    Router.push({ path: 'products' })
  }

  colors: any = colorsChart

  protected async mounted() {
    await this.loadScannings()
  }
}
